import { forwardRef, useCallback, useState } from 'react';

import { FormInputText, IFormInputTextProps } from '../FormInput';
import { FormInputActionBase } from '../FormInputActions';
import { LockedIcon, UnLockedIcon } from './styles';

export interface IFormInputPasswordProps
  extends Omit<IFormInputTextProps, 'type'> {
  showPassword?: boolean;
  onShowPasswordChange?: () => void;
}

export const FormInputPassword = forwardRef<
  HTMLInputElement,
  IFormInputPasswordProps
>(
  // eslint-disable-next-line no-restricted-syntax
  function FormInputPassword(
    {
      dataCy,
      name,
      autoComplete = 'off',
      showPassword: showPasswordOverwritten,
      onShowPasswordChange,
      ...inputProps
    }: IFormInputPasswordProps,
    ref
  ): JSX.Element {
    const [showPassword, setShowPassword] = useState(false);

    const showPasswordAux = showPasswordOverwritten ?? showPassword;

    const handleTogglePassword = useCallback(() => {
      onShowPasswordChange?.();
      if (showPasswordOverwritten !== undefined) {
        setShowPassword(showPasswordOverwritten);
      } else {
        setShowPassword((prev) => !prev);
      }
    }, [onShowPasswordChange, showPasswordOverwritten]);

    return (
      <>
        <FormInputText
          {...inputProps}
          ref={ref}
          autoComplete={autoComplete}
          dataCy={dataCy}
          name={name}
          type={showPasswordAux ? 'text' : 'password'}
        />
        <FormInputActionBase
          dataCy={showPasswordAux ? 'icon-locked' : 'icon-unlocked'}
          icon={showPasswordAux ? LockedIcon : UnLockedIcon}
          onClick={handleTogglePassword}
        />
      </>
    );
  }
);
